
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ThirdPartPreTransformConfigurationResponse } from '~modules/thirdparts/common/dto/third-part-pre-transform-configuration-configuration-response.dto';
import { ThirdPartsType } from '../entities/third-parts-type.constant';

@Injectable()
export class CommonThirdPartsConfigurationFetcherService {

constructor(private readonly http: HttpClient) { }

    getGlobalConnectorConfigurationFromThirdPartApi(
        authenticationId: number,
        thirdPartType: ThirdPartsType | null
    ): Observable<ThirdPartPreTransformConfigurationResponse> {
        const path = `${environment.apiURL}/third-parts/authentication/${authenticationId}/configuration`;
        if (thirdPartType) {
            return this.http.get<ThirdPartPreTransformConfigurationResponse>(path, {
                params: {
                    thirdPartType
                }
            });
        } else {
            return of();
        }
    }
}